<template>
  <div>
    <Header>
      Historia rezerwacji
    </Header>

    <ReservationFilters
      :value="search"
      :barbers="barbers"
      @filter-change="onFilterChange"
    />

    <div v-if="searching" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <ReservationLogCard
        v-for="log in localLogs"
        :key="log.id"
        :log="log"
      />
    </template>

    <div v-if="loading" class="text-center py-3">
      <b-spinner small variant="primary" />
    </div>

    <div v-if="!hasMore && localLogs.length" class="text-center text-muted py-3">
      Brak kolejnych wyników
    </div>

    <div ref="scrollAnchor" />
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import ReservationFilters from '@/Components/Log/ReservationFilters'
import ReservationLogCard from '@/Components/Log/ReservationLogCard'

export default {
  layout: Layout,
  components: {
    Header,
    ReservationFilters,
    ReservationLogCard,
  },
  props: {
    logs: Array,
    barbers: Array,
    filters: Object,
    has_more: Boolean,
    next_cursor: [Number, String],
  },
  data() {
    return {
      localLogs: this.logs || [],
      hasMore: this.has_more,
      cursor: this.next_cursor,
      loading: false,
      searching: false,
      isLoadingMore: false,
      observer: null,
      search: {
        phone: this.filters?.phone || '',
        barber_id: this.filters?.barber_id || '',
        type: this.filters?.type || '',
      },
    }
  },
  watch: {
    logs(newLogs) {
      if (this.isLoadingMore) return
      this.localLogs = newLogs
      this.hasMore = this.has_more
      this.cursor = this.next_cursor
    },
  },
  methods: {
    onFilterChange(filters) {
      this.search = filters
      this.doSearch()
    },
    doSearch() {
      this.localLogs = []
      this.cursor = null
      this.hasMore = false
      this.searching = true
      this.$inertia.get(this.route('logs.reservations'), this.search, {
        replace: true,
        preserveState: true,
        onFinish: () => {
          this.searching = false
        },
      })
    },
    loadMore() {
      if (this.loading || !this.hasMore || !this.cursor) return
      this.loading = true
      this.isLoadingMore = true
      this.$inertia.get(this.route('logs.reservations'), {
        ...this.search,
        cursor: this.cursor,
      }, {
        replace: true,
        preserveState: true,
        preserveScroll: true,
        onSuccess: (page) => {
          this.localLogs = [...this.localLogs, ...page.props.logs]
          this.hasMore = page.props.has_more
          this.cursor = page.props.next_cursor
        },
        onFinish: () => {
          this.loading = false
          this.isLoadingMore = false
        },
      })
    },
    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.loadMore()
        }
      }, { rootMargin: '200px' })
      this.observer.observe(this.$refs.scrollAnchor)
    },
  },
  mounted() {
    this.initObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>
